import { useEffect, useRef } from "react";

export function useUnityOverlayBridge(iframeRef, handlers) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    const onMsg = e => {
      const data = e?.data;
      if (!data || typeof data.type !== "string") return;
      const iframe = iframeRef?.current;
      if (!iframe || e.source !== iframe.contentWindow) return;

      const h = handlersRef.current;

      if (data.type === "rtwx-overlay-anchor-pose") {
        if (!h.onPose) return;
        const id = data.id;
        if (!id || typeof id !== "string") return;
        h.onPose(
          id,
          Number(data.normX),
          Number(data.normY),
          data.visible !== false,
          data.percentX != null ? Number(data.percentX) : undefined,
          data.percentY != null ? Number(data.percentY) : undefined,
        );
        return;
      }

      if (data.type === "rtwx-image-pointer") {
        if (!h.onPointer) return;
        const normX = Number(data.normX);
        const normY = Number(data.normY);
        if (!Number.isFinite(normX) || !Number.isFinite(normY)) return;
        h.onPointer(data.phase, normX, normY);
        return;
      }

      if (data.type === "rtwx-unity-mousemove") {
        if (!h.onUnityMouse) return;
        const rect = iframe.getBoundingClientRect();
        h.onUnityMouse(
          rect.left + Number(data.clientX),
          rect.top + Number(data.clientY)
        );
        return;
      }

      if (data.type === "rtwx-image-ready") {
        h.onImageReady?.();
        return;
      }

      if (data.type === "rtwx-image-loading") {
        h.onImageLoading?.();
      }
    };

    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [iframeRef]);
}
